import { useEffect } from "react";

export default function ChatAdminParentRoot() {
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      // const backend_apis = [backendApi]
      if (window.MyPackage) {
        window.MyPackage.loadAdminBox("load_qchat");
      } else {
        console.warn("MyPackage is not loaded yet. Skipping init???.");
      }
    }, 1000);

    return () => {
      clearTimeout(timeoutId);

      // 🔥 This will run when user leaves the page / component unmounts
      // if (window.MyPackage && window.MyPackage.disolveAdminBox) {
      //   window.MyPackage.disolveAdminBox("load_qchat");
      // }

      if (window.MyPackage && window.MyPackage.disconnect) {
        window.MyPackage.disconnect();
      }
    };
  }, []);

  return null;
}
